import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HoverIntent from '@liveauctioneers/caterwaul-components/lib/HoverIntent/HoverIntent';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import noop from '@/utils/noop';
import styled, { css } from 'styled-components';

type Props = {
    active: boolean;
    closeNav: () => void;
    link: string;
    mobile: string;
    msgId: string;
    openNav: React.ComponentProps<typeof HoverIntent>['onMouseOver'];
    tabletNavigation: (link: string, key: string) => void;
};

const MegaNavLink = (props: Props) => {
    const { active, closeNav, link, mobile, msgId, openNav, tabletNavigation } = props;

    const isPhone = mobile && mobile !== 'tablet';
    const isTablet = mobile === 'tablet';
    return (
        <HoverIntent
            interval={50}
            onMouseOut={noop}
            onMouseOver={isTablet ? noop : openNav}
            sensitivity={5}
            timeout={50}
        >
            <StyledMegaNavLink $active={active && !isPhone}>
                <Link onClick={!isTablet ? closeNav : tabletNavigation} primaryWeak route to={isTablet ? '' : link}>
                    <FormattedMessage id={msgId} />
                </Link>
            </StyledMegaNavLink>
        </HoverIntent>
    );
};

export default React.memo<Props>(MegaNavLink, isEqual);

const StyledMegaNavLink = styled.div<{ $active: boolean }>`
    height: 100%;
    align-items: center;
    padding: 0 12px;
    display: flex;

    & > a {
        text-decoration: none;
        font-size: 14px;
        font-family: ${({ theme }) => theme.typography.fontSecondary};
    }

    @media (min-width: 976px) {
        padding: 10px 13px;
        font-size: 16px;

        & > a {
            font-size: 16px;
        }
    }

    ${({ $active, theme }) =>
        $active &&
        css`
            border-top: 4px solid ${theme.colors.white};
            border-bottom: 4px solid ${theme.colors.blue100};
        `};
`;
